<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-img :src="bannerURL" aspect-ratio="2"></v-img>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div class="title mt-2">{{propertyDeveloperName}}</div><br>
        <div class="subtitle-1 mb-2">{{subtitle}}</div>
        <div class="body-1">{{description}}</div>
        <div class="body-2 mt-2">{{propertyDeveloper.data.address}}</div>
        <div class="text-center mt-5">
          <v-btn class="mx-2" text>
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn class="mx-2" text>
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
          <v-btn class="mx-2" text>
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn class="mx-2" text>
            <v-icon>mdi-youtube</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const env = window.localStorage.getItem('env')
export default {
  computed: {
    propertyDeveloperName () {
      return this.propertyDeveloper.name || ''
    },
    subtitle () {
      return this.propertyDeveloper.data.subtitle || ''
    },
    description () {
      return this.propertyDeveloper.data.description || ''
    },
    address () {
      return this.propertyDeveloper.data.address || ''
    },
    bannerURL () {
      const config = this.$store.getters['app/config']
      var url = ''
      if (config && this.propertyDeveloper) {
        url = `${config.assetServerURL}/${env}${this.propertyDeveloper.data.bannerImage}`
      }
      return url
    },
    propertyDeveloper () {
      return this.$store.getters['propertyDeveloper/loadedItem']
    }
  },
  created () {
    console.log('About.vue')
    this.$store.dispatch('propertyDeveloper/view', this.$route.params.id)
  }
}
</script>
